import React, { useState } from 'react'
import { BasicDropdown, Button } from '../../../components'
import { useHistory } from 'react-router-dom'
import { GuestContent } from './guest-content'

const options = [{label: '1', value: 1}]

const TicketContent = ({isMobile, handleClose, setStep, data}) => {
  const history = useHistory()

  return (
    <div>
      <p className="text-lg lg:text-2xl font-bold mb-3">
        {data.title}
      </p>
      <div className="text-gray-444 text-sm">
        <div className="mb-2" dangerouslySetInnerHTML={{__html: data.location}}></div>
        <div className="" dangerouslySetInnerHTML={{__html: data.dateAndTime}}></div>
      </div>

      <hr className="my-5 lg:my-10"/>

      <div className="flex flex-wrap justify-between lg:items-center w-full text-xs lg:text-sm text-gray-444">
        <div style={{maxWidth: isMobile ? '137px' : ''}}>
          <p className="font-bold">Ticket for {data.title}</p>
        </div>
        <div>
          <p>FREE</p>
        </div>
        <div style={{minWidth: '70px'}}>
          <BasicDropdown
            options={options}
            defaultValue={options[0]}
            noMarginBottom
            disabled={true}
          />
        </div>
      </div>

      <hr className="mt-5 mb-8 lg:mt-10 lg:mb-10"/>

      <div className="flex justify-end">
        <div style={{width: isMobile ? '100%' : '170px'}} onClick={() => !isMobile ? setStep('guest') : history.push('/event/register')}>
          <Button className="hidden lg:block">
            Register
          </Button>
          <div className="lg:hidden">
            <Button thin>
              Register
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

const RegisterPopup = ({onClose, isMobile, data}) => {
  const [step, setStep] = useState('ticket')

  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()

    onClose(false)
  }

  return (
    <div
      className="fixed left-0 top-0 w-full h-screen flex justify-center items-center"
      style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)'}}
      onClick={handleClose}
    >
      <div className="container mx-auto" onClick={(e) => e.stopPropagation()}>
        <div className="lg:w-10/12 mx-auto pt-8 pb-5 lg:pt-20 lg:pb-20 px-5 lg:px-24 bg-white rounded overflow-y-auto" style={{maxHeight: '100vh'}}>
          {
            step === 'ticket' &&
            <TicketContent isMobile={isMobile} handleClose={handleClose} setStep={setStep} data={data}/>
          }
          {
            step === 'guest' &&
            <GuestContent isMobile={isMobile} handleClose={handleClose} setStep={setStep} data={data}/>
          }
        </div>
      </div>
    </div>
  )
}

export { RegisterPopup }